<!-- 留言评论 -->
<template>
	<el-dialog class="com-dialog comment-dialog"
		title="留言评论"
		:visible.sync="visible"
		width="1000px">
		
		<div class="content">
			<div class="title">
				<span>“多材料医疗3D打印机”</span>的留言，共<span>12</span>条
			</div>
		</div>


		<span slot="footer" class="dialog-footer">
			<el-button @click="visible = false">取 消</el-button>
			<el-button type="primary" @click="visible = false">确 定</el-button>
		</span>
	</el-dialog>
</template>
<script>
export default {
	name: 'commentDialog',
	data () {
		return {
			visible: false,
		}
	},
	methods: {
		open() {
			this.visible = true;
		}
	}
}	
</script>
<style lang="scss" scoped>
.comment-dialog {
	.title {
		line-height: 46px;
		border-bottom: 5px solid #F3F3F5;
	}
}
</style>

